import StatisticsContent from "./StatisticsContent/StatisticsContent"
import classes from './Statistics.module.scss'

const Statistics = () => {

    return (
        <div className={classes.projectsContainer}>
                <StatisticsContent/>
        </div>
    )
}

export default Statistics